// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host.right-aligned {
  text-align: right;
  padding-right: 15px;
}
:host.right-aligned .CcmList-Header-Item-Text {
  float: right;
}
:host.right-aligned .OrderBy {
  margin-right: 8px;
}
:host.padding-right-small {
  padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/items-list/head-item/head-item.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,YAAA;AAAZ;AAGQ;EACI,iBAAA;AADZ;AAII;EACI,kBAAA;AAFR","sourcesContent":[":host {\r\n    &.right-aligned {\r\n        text-align: right;\r\n        padding-right: 15px;\r\n\r\n        .CcmList-Header-Item-Text {\r\n            float: right;\r\n        }\r\n\r\n        .OrderBy {\r\n            margin-right: 8px;\r\n        }\r\n    }\r\n    &.padding-right-small {\r\n        padding-right: 5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
